import './arduino-cloud.scss';

import { graphql, useStaticQuery } from 'gatsby';
import React, { useMemo } from 'react';

import Banner from '../components/Banner/Banner';
import { IconArrowUpRightTeal } from '../components/Icons';
import Layout from '../components/Layout';
import NestedPages from '../components/pages/NestedPages/NestedPages';
import PageTitle from '../components/PageTitle/PageTitle';
import SEO from '../components/seo';
import SideBar from '../components/SideBar/SideBar';
import VideoWithInfo from '../components/VideoWithInfo/VideoWithInfo';
import { StaticPageProps } from '../entities/Page';
import ConnectAndContribute from '../components/ConnectAndContribute/ConnectAndContribute';
import CloudImage from '../assets/cloud.svg';
import { getCloudSideBarDataRefactored } from '../utils/functions';

export default function Cloud(): React.ReactElement {
  const data: StaticPageProps = useStaticQuery(pageQuery);

  const cloudRefactoredData = useMemo(() => {
    return getCloudSideBarDataRefactored(data);
  }, [data]);

  return (
    <Layout>
      <SEO title="Arduino Cloud" description="Configure, program and connect your devices - all through the Arduino Cloud." />
      <main className="page-container">
        <SideBar links={[]} nestedCategories={cloudRefactoredData} actualPage={'Cloud'} />
        <div className="page-layout arduino-cloud">
          <PageTitle title="Arduino Cloud" description="Configure, program and connect your devices - all through the Arduino Cloud." />
          <Banner
            title="Discover Arduino Cloud"
            description="The Arduino Cloud is a online platform that makes it easy for you to create, deploy and monitor IoT projects."
            image={CloudImage}
            cta={[{ url: 'https://create.arduino.cc/iot/things', label: 'ARDUINO CLOUD', icon: <IconArrowUpRightTeal />, external: true }]}
          />
          <section className="arduino-cloud__subtitle">
            <h3>Getting Started</h3>
            <p>The Arduino Cloud is a online platform that makes it easy for you to create, deploy and monitor IoT projects.</p>
          </section>
          <VideoWithInfo video={data.video.childMdx.frontmatter.url} info={data.video.childMdx.frontmatter.info} />
          <NestedPages>{data.pages}</NestedPages>
          <ConnectAndContribute />
        </div>
      </main>
    </Layout>
  );
}

export const pageQuery = graphql`
  {
    pages: allFile(filter: { fields: { type: { eq: "arduino-cloud" } } }, sort: { relativeDirectory: ASC }) {
      edges {
        node {
          relativeDirectory
          name
          fields {
            slug
          }
          childMdx {
            frontmatter {
              title
              description
              icon
            }
          }
        }
      }
    }
    video: file(relativePath: { eq: "arduino-cloud/videoInfo.md" }) {
      relativeDirectory
      childMdx {
        body
        frontmatter {
          url
          info {
            icon
            title
            description
            link
          }
        }
      }
    }
  }
`;
